// ForgotPassword.js
import React, { useState } from 'react';
import api from '../../services/api';
import { useNavigate } from 'react-router-dom';
import './ForgotPassword.css';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const response = await api.post(`/api/request-reset`, {
        email,
      });
      const data = await response.data;

      if (data?.success) {
          navigate(`/reset-password?email=${encodeURIComponent(email)}`);
      } else {
        setError(data.error || 'Failed to generate reset code.');
        setMessage('');
      }

    } catch (error) {
      setError(error?.response?.data?.error || 'Failed to send reset code. Please try again.');
      setMessage('');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="forgot-password-container">
      <h2>Forgot Password</h2>
      {message && <p className="success-message">{message}</p>}
      {error && <p className="error-message">{error}</p>}
      <form onSubmit={handleForgotPassword} className="forgot-password-form">
        <div className="input-group">
          <input
            type="email"
            placeholder="Email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="form-input"
          />
        </div>
        <button
          type="submit" 
          className="forgot-password-button button-loading" 
          disabled={isLoading}
        >
          {isLoading ? <div className="spinner" /> : 'Send Reset Code'}
        </button>
      </form>
    </div>
  );
};

export default ForgotPassword;